import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "map-item" }
const _hoisted_2 = { class: "map-item-image-wrapper" }
const _hoisted_3 = ["alt", "src"]
const _hoisted_4 = { class: "map-item-text" }
const _hoisted_5 = { class: "map-item-text-title" }
const _hoisted_6 = { class: "map-item-text-timeline" }
const _hoisted_7 = { class: "map-item-text-quip" }
const _hoisted_8 = { class: "map-item-text-desc" }


import { MapItemData } from '@/models/data'

export default /*#__PURE__*/_defineComponent({
  __name: 'MapItem',
  props: {
    item: null
  },
  setup(__props: any) {

const props = __props as {
  item: MapItemData,
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "map-item-image-img",
        alt: __props.item.img,
        src: require('../assets/map/' + __props.item.img + '.png')
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(__props.item.name), 1),
      _createElementVNode("div", _hoisted_6, _toDisplayString(__props.item.timeline), 1),
      _createElementVNode("div", _hoisted_7, _toDisplayString(__props.item.quip), 1),
      _createElementVNode("div", _hoisted_8, _toDisplayString(__props.item.desc), 1)
    ])
  ]))
}
}

})